module.exports = __webpack_public_path__ + "static/media/gnurl.7687762f.svg";